import { useState, useEffect } from 'react';
import { adminGet } from '../lib/api';

const STAGES = [
  'Document Intake', 'Format Detection', 'Text Extraction', 'Structure Analysis',
  'Clause Segmentation', 'Posture Assignment', 'Jurisdiction Mapping',
  'Clause Risk Assessment', 'Compliance Cross-Reference', 'Severity Scoring',
  'Recommendation Generation', 'Dossier Assembly', 'Attestation Anchoring', 'Quality Verification',
];

interface QueueItem { id: string; posture: string; jurisdiction: string; status: string; failedStage: number; createdAt: number; }

export function ReviewQueue() {
  const [queue, setQueue] = useState<QueueItem[]>([]);

  useEffect(() => {
    (async () => {
      const resp = await adminGet('/api/admin/review-queue');
      if (resp.ok && resp.data) setQueue((resp.data as { queue: QueueItem[] }).queue || []);
    })();
  }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-display font-bold text-white">Review Queue</h1>
          {queue.length > 0 && (
            <span className="px-2 py-0.5 text-xs bg-severity-high/10 text-severity-high rounded-full">{queue.length}</span>
          )}
        </div>
        <button onClick={() => window.location.reload()}
          className="px-3 py-1.5 text-sm bg-rights-500/10 text-rights-500 rounded-lg border border-rights-500/20">Refresh</button>
      </div>

      {queue.length === 0 ? (
        <div className="bg-dark-700 rounded-2xl border border-dark-650/50 p-12 text-center">
          <span className="material-symbols-outlined text-4xl text-severity-low mb-3 block">check_circle</span>
          <p className="text-white font-medium">Queue is empty</p>
          <p className="text-sm text-dark-400 mt-1">No items require manual review right now.</p>
        </div>
      ) : (
        <div className="bg-dark-700 rounded-2xl border border-dark-650/50 overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-dark-650/50">
                <th className="px-4 py-3 text-left text-xs font-medium text-dark-400 uppercase">Pipeline</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-dark-400 uppercase">Failed Stage</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-dark-400 uppercase">Posture</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-dark-400 uppercase">State</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-dark-400 uppercase">Status</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-dark-400 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-dark-650/30">
              {queue.map(item => (
                <tr key={item.id} className="hover:bg-dark-750/50 transition-colors">
                  <td className="px-4 py-3 text-sm text-dark-300 font-mono">{item.id.substring(0, 16)}...</td>
                  <td className="px-4 py-3">
                    <span className="px-2 py-0.5 text-xs bg-dark-800 text-dark-300 rounded">
                      S{item.failedStage}: {STAGES[item.failedStage - 1] || 'Unknown'}
                    </span>
                  </td>
                  <td className="px-4 py-3"><span className="px-2 py-0.5 text-xs bg-rights-500/10 text-rights-500 rounded">{item.posture}</span></td>
                  <td className="px-4 py-3"><span className="px-2 py-0.5 text-xs bg-dark-800 text-dark-400 rounded">{item.jurisdiction}</span></td>
                  <td className="px-4 py-3"><span className="px-2 py-0.5 text-xs bg-severity-high/10 text-severity-high rounded">{item.status}</span></td>
                  <td className="px-4 py-3">
                    <button className="px-2 py-1 text-xs bg-rights-500/10 text-rights-500 rounded hover:bg-rights-500/20 transition-colors">Review</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
